import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';
import { LoaderProvider } from './Utils/ContextHelper/LoaderContext';
import SimsolaLoader from './Components/V1/Loader/SimsolaLoader';
import { initPostHog } from './Utils/analytics';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<React.StrictMode>
		<HelmetProvider>
			<LoaderProvider>
				<SimsolaLoader />
				<App />
			</LoaderProvider>
		</HelmetProvider>
	</React.StrictMode>
);

// Started right after render: posthog-js is already code-split via dynamic import
// (see analytics.ts), so this doesn't block paint — and clicks can happen within
// a second or two of load, before which trackCta/decorateCrossDomainUrl would
// otherwise silently no-op.
initPostHog();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
